import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/coach/createCoach.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { coachRoutes } from "../../routers/CoachRouters";
import Swal from "sweetalert2";
import Close_Button from "../../assets/auth/close.png";
import sucess from "../../assets/exercise/success.png";
import { dispatch, toggle } from "../../redux";
import { createCoachService, getGyms } from "../../services";

const CreateCoachAccount = () => {
  const { isLoading, profile, gyms } = useSelector((state) => state.coach);
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  const navigate = useNavigate();
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  // Form state for coach creation
  const [formData, setFormData] = useState({
    name: "",
    gym: "",
    phone: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    getGyms();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Coach name is required";
    }

    if (!formData.gym) {
      newErrors.gym = "Gym selection is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = async () => {
    if (!validateForm()) {
      return;
    }

    console.log("Creating coach:", formData);

    try {
      // Replace with your actual API call
      const success = await createCoachService(formData);

      if (success) {
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
              <button 
                id="customCloseButton" 
                style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
                <img 
                  src=${Close_Button} 
                  alt="Close" 
                  style="width: 50px; height: 50px;"
                />
              </button>
              <img 
                src=${sucess} 
                alt="Success" 
                style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
              />
              <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Coach Created!</h2>
              <br/>
              <p style="font-family: 'Gotham Book', sans-serif;">
                You've successfully created a new coach account.
              </p>
              <br/>
              <button 
                id="okButton" 
                style="
                  background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                  color: #f3f3f6; 
                  padding: 10px 30px; 
                  border: none; 
                  border-radius: 5px; 
                  cursor: pointer; 
                  margin-top: 20px; 
                  font-family: 'gothambold', sans-serif;
                ">
               Close
              </button>
            </div>
          `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const okButton = document.getElementById("okButton");
            okButton.addEventListener("click", () => {
              Swal.close();
              setFormData({
                name: "",
                gym: "",
                phone: "",
                email: "",
              });
              navigate(coachRoutes.listCoach);
            });
          },
        });
      }
    } catch (error) {
      console.error("Error creating coach:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to create coach account. Please try again.",
        icon: "error",
        confirmButtonColor: "#f79328",
      });
    }
  };

  const handleCancel = () => {
    navigate(coachRoutes.dashboard);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.listCoach}>HOME / </Link>
          <span>CREATE COACH ACCOUNT</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>CREATE COACH ACCOUNT</h3>
            </div>
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            {isLoading ? (
              <div className={Styles.loading_container}>
                <p>Loading...</p>
              </div>
            ) : (
              <div className={Styles.profile_form}>
                <div className={Styles.form_grid}>
                  {/* Four column row for all fields */}
                  <div className={Styles.four_column_row}>
                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Coach Name</label>
                      <input
                        type="text"
                        className={`${Styles.form_input} ${
                          errors.name ? Styles.error : ""
                        }`}
                        value={formData.name}
                        onChange={(e) =>
                          handleInputChange("name", e.target.value)
                        }
                        placeholder="Enter here"
                      />
                      {errors.name && (
                        <span className={Styles.error_message}>
                          {errors.name}
                        </span>
                      )}
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>
                        Gym Name (Branch)
                      </label>
                      <select
                        className={`${Styles.form_input} ${
                          Styles.dropdown_select
                        } ${errors.gym ? Styles.error : ""}`}
                        value={formData.gym}
                        onChange={(e) =>
                          handleInputChange("gym", e.target.value)
                        }
                      >
                        <option value="" disabled>
                          Choose from list
                        </option>
                        {gyms && gyms.length > 0 ? (
                          gyms.map((gym) => (
                            <option key={gym._id} value={gym._id}>
                              {gym.name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No gyms available
                          </option>
                        )}
                      </select>
                      {errors.gym && (
                        <span className={Styles.error_message}>
                          {errors.gym}
                        </span>
                      )}
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Phone Number</label>
                      <input
                        type="tel"
                        className={`${Styles.form_input} ${
                          errors.phone ? Styles.error : ""
                        }`}
                        value={formData.phone}
                        onChange={(e) => {
                          const numericValue = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 10);
                          handleInputChange("phone", numericValue);
                        }}
                        onKeyPress={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            ![
                              "Backspace",
                              "Delete",
                              "Tab",
                              "Escape",
                              "Enter",
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter here"
                      />
                      {errors.phone && (
                        <span className={Styles.error_message}>
                          {errors.phone}
                        </span>
                      )}
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Email ID</label>
                      <input
                        type="email"
                        className={`${Styles.form_input} ${
                          errors.email ? Styles.error : ""
                        }`}
                        value={formData.email}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        placeholder="Enter here"
                      />
                      {errors.email && (
                        <span className={Styles.error_message}>
                          {errors.email}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className={Styles.borderbottomline}></div>

                <div className={Styles.button_group}>
                  <button className={Styles.save_button} onClick={handleCreate}>
                    Create
                  </button>
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCoachAccount;
